import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import EditCustomWidgetModal from "./EditCustomWidgetModal";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";

const useStyles = makeStyles(theme => ({
  root: {
    "& a": {
      textDecoration: "underline"
    }
  }
}));

const CustomWidget = props => {
  const { widgetData, currentUser, onUpdateCustomWidget, dashboard } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [newWidgetData, setNewWidgetData] = useState(widgetData);
  const handleMenuItemClick = item => {
    if (item.value === "edit") {
      setModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const renderMenuOptions = (currentUser, t) => {
    if (
      !currentUser.permissions.silver &&
      (currentUser.isAdmin ||
        (widgetData.isPrivate &&
          (currentUser.permissions.isEmployeeManager ||
            currentUser.permissions.customRoleEnabled ||
            currentUser.permissions.allowValidate)))
    ) {
      return [{ value: "edit", label: t("customWidget.options.edit") }];
    } else {
      return [];
    }
  };
  return (
    <DashboardWidgetContainer
      dashboard={dashboard}
      widgetKey={newWidgetData.i}
      title={newWidgetData.name}
      menuProps={{
        options: renderMenuOptions(currentUser, t),
        onMenuItemClick: handleMenuItemClick
      }}
    >
      <div
        className={classes.root}
        dangerouslySetInnerHTML={{ __html: newWidgetData.content }}
      />
      <EditCustomWidgetModal
        widgetData={newWidgetData}
        open={modalOpen}
        onUpdateCustomWidget={onUpdateCustomWidget}
        onClose={handleModalClose}
        ownPrivateWidget={currentUser.id === newWidgetData.creatorId}
        setWidgetContent={setNewWidgetData}
      />
    </DashboardWidgetContainer>
  );
};

CustomWidget.propTypes = {
  /**
   * Data that will be displayed in the widget / edit form
   */
  widgetData: PropTypes.object,
  /**
   * The user that is interacting with the Dashboard
   */
  currentUser: PropTypes.object,
  /**
   * function to call when updating the widget
   */
  onUpdateCustomWidget: PropTypes.func,
  dashboard: PropTypes.string
};

export default CustomWidget;
